import ahProducten from '../data/ah-producten.json';

interface CatalogusRegel {
  categorie: string;
  naam: string;
  eenheid: string;
  /** Het productnummer van AH (de cijfers uit `wi123456` in hun product-URL). */
  ahId?: number;
  /** Woorden waarop dit product ook te vinden moet zijn. Nodig zodra de
   *  productnaam het soort niet noemt: "AH Les pains boulogne heel" is brood,
   *  maar wie "brood" typt zou hem zonder dit nooit zien. */
  zoektermen?: string[];
}

const CATALOGUS: CatalogusRegel[] = ahProducten;

/** Zelfde normalisatie als bij het zoeken: leestekens en accenten tellen niet mee. */
const sleutel = (naam: string) =>
  naam
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

const opNaam = new Map<string, number>();
for (const regel of CATALOGUS) {
  if (regel.ahId) opNaam.set(sleutel(regel.naam), regel.ahId);
}

/** Het AH-productnummer bij deze naam, of `null` als we het product niet kennen. */
export function zoekAhId(naam: string): number | null {
  return opNaam.get(sleutel(naam)) ?? null;
}
